<div class="report-categories-page" *ngIf="isBaseRoute()">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CATEGORÍAS KPI</h1>
                <p class="page-subtitle text-muted">
                    Asigne reportes Power BI a categorías: operativo, financiero
                    o gerencial. Cada categoría corresponde a un módulo KPI
                    independiente.
                </p>
            </div>
            <div class="header-actions">
                <button
                    mat-button
                    (click)="onBack()"
                    class="me-2"
                    matTooltip="Volver a Módulos"
                >
                    <mat-icon>arrow_back</mat-icon>
                    Volver
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="onCreate()"
                    matTooltip="Asignar reporte a categoría"
                >
                    <mat-icon>add</mat-icon>
                    Asignar Reporte
                </button>
            </div>
        </div>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div class="report-categories-list-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort>
                        <!-- Report Name Column -->
                        <ng-container matColumnDef="reportName">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                class="pl-0"
                            >
                                Reporte
                            </th>
                            <td mat-cell *matCellDef="let element" class="pl-0">
                                <div class="report-info">
                                    <h6 class="mt-0 mb-0">
                                        {{ element.reportName }}
                                    </h6>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Report ID Column -->
                        <ng-container matColumnDef="reportId">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Report ID
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <code>{{ element.reportId }}</code>
                            </td>
                        </ng-container>

                        <!-- Category Column -->
                        <ng-container matColumnDef="category">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Categoría
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="category-badge"
                                    [ngClass]="
                                        getCategoryClass(element.category)
                                    "
                                >
                                    {{ getCategoryLabel(element.category) }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                class="text-end pr-0"
                            ></th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="text-end pr-0"
                            >
                                <div class="action">
                                    <button
                                        type="button"
                                        mat-button
                                        class="p-0 min-w-auto lh-1 h-auto"
                                        (click)="deleteMapping(element)"
                                        matTooltip="Quitar de esta categoría"
                                    >
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>
                <mat-paginator
                    [pageSizeOptions]="[10, 25, 50, 100]"
                ></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<router-outlet></router-outlet>
